<template>
  <div class="main-page page-all-service">
    <Menu title="全部服务" :home="true" />
    <div class=" container-flex all-service-container">
      <div class="all-service-right" id="scrollBox">
        <div v-for="(item, index) in service_type" :key="index" :id="'type-' + index" class="service-type">

          <div class="service-right-title">
            {{item.type}}
          </div>
          <ul class="service-right-list">
            <li v-for="(listitem, idx) in service_type[index].children" :key="idx" :class="listitem.extra">
              <div class="service-icon" @click="toLink(listitem)">
                <div v-if="listitem.image" class="img-icon">
                  <img :src="listitem.image" alt="">
                </div>
                <div v-else :class="'icon icon-' + listitem.icon">
                  <i :class="'iconfont ' + listitem.img"></i>
                </div>
                <div class="title">

                  {{listitem.name}}
                </div>
              </div>
            </li>
            <li v-if="index==1 && showScztGuide" :class="scztGuide.extra">
              <div class="service-icon" @click="toLink(scztGuide)">
                <div :class="'icon icon-' + scztGuide.icon">
                  <i :class="'iconfont ' + scztGuide.img"></i>
                </div>
                <div class="title">
                  {{scztGuide.name}}
                </div>
              </div>
            </li>
          </ul>
        </div>

      </div>
    </div>

  </div>
</template>
<script>

import Menu from '../components/Menu'
import { ADVISORY_INQUIRE, TRAVEL_DISPUTES, LAW_INQUIRE, CALC_INQUIRE, EXAM_INQUIRE } from '../datas/constants/statistics'
export default {
  components: {
    Menu
  },
  data () {
    return {
      service_type: [
        {
          type: '法律服务',
          children: [
            {
              name: '涉外法律服务',
              image: 'https://qiniu.laway.cn/publaw/2eb7c192f6aa11f09d5bfa2800184358.png',
              url: '/dnaservice'
            },
            {
              name: '精准法律咨询',
              icon: 'yellow',
              img: 'iconfalvzixun',
              outerlink: `${this.$store.state.app.appSite}/terminal?code=${this.$store.state.device.point.code}&machineId=${this.$store.state.device.point.no}`,
              name: '精准法律咨询',
              statistics: ADVISORY_INQUIRE
            },
            {
              name: '法律文书模板',
              icon: 'blue',
              img: 'iconwenshuxiazai',
              url: '/service/11'
            },
            {
              name: '法律计算器',
              icon: 'purple',
              img: 'iconjisuanqi',
              statistics: CALC_INQUIRE,
              outerlink: `${this.$store.state.app.appSite}/terminal/calc?code=${this.$store.state.device.point.code}&machineId=${this.$store.state.device.point.no}`,
            },
            {
              name: '留言咨询',
              img: 'iconliuyanzixun',
              url: '/service/10',
              icon: 'lightgreen'
            },
            {
              name: '企业法治体检',
              img: 'iconfazhitijian',
              statistics: EXAM_INQUIRE,
              outerlink: `${this.$store.state.app.appSite}/terminal/exam?code=${this.$store.state.device.point.code}&machineId=${this.$store.state.device.point.no}&clean_enterprise=1`,
              icon: 'red'
            }
          ]
        },
        {
          type: '业务申办查询',
          children: [
            {
              name: '法律援助',
              icon: 'red',
              img: 'iconfalvyuanzhu',
              url: '/service/6'
            },
            {
              name: '人民调解',
              icon: 'purple',
              img: 'iconrenmintiaojie',
              url: '/service/0'

            },
            {
              name: '公证服务',
              icon: 'green',
              img: 'icongongzhengbanli',
              url: '/service/2'
            },
            {
              name: '司法鉴定',
              icon: 'blue',
              img: 'iconsifajianding',
              url: '/service/3'

            },
            {
              name: '仲裁',
              img: 'iconzhongcai',
              icon: 'lightgreen',
              url: '/service/13'
            },
            {
              name: '行政复议',
              img: 'iconhangzhengfuyi',
              icon: 'blue',
              url: '/service/fuyi'
            }

          ]
        },
        {
          type: '学法用法',
          children: [
            {
              name: '普法动态',
              icon: 'blue',
              img: 'iconpufadongtai',
              url: '/pufa?show_tab=true'
            },
            {
              name: '以案释法',
              icon: 'yellow',
              img: 'iconyianshifa',
              url: '/yasf'
            }

          ]
        },

        {
          type: '特色栏目',
          children: [
            {
              name: '一带一路服务',
              icon: 'lightblue',
              img: 'iconyidaiyilu',
              url: '/service/9'
            },
            {
              name: '乡村振兴法律服务',
              icon: 'green',
              img: 'iconfalvfuwufupin',
              url: '/service/7'
            },
            {
              name: '少数民族法规',
              icon: 'purple',
              img: 'iconshaoshuminzufagui',
              url: '/service/8'
            },
            {
              name: '旅游纠纷',
              icon: 'red',
              img: 'iconlvyoujiufen',
              outerlink: `${this.$store.state.app.appSite}/terminal/g/89A437E40C884DEAA53169647F3A0B52?action=start&code=${this.$store.state.device.point.code}&machineId=${this.$store.state.device.point.no}`,
              statistics: TRAVEL_DISPUTES
            },
            // {
            //   name: '扫黑除恶',
            //   icon: 'yellow',
            //   img: 'iconsaoheichue',
            //   url: '/saohei'
            // }
          ]
        },
        {
          type: '查询服务',
          children: [
            {
              name: '法律法规查询',
              icon: 'lightblue',
              img: 'iconfalvfagui',
              outerlink: `${this.$store.state.app.appSite}/cus/law-ter/law?code=${this.$store.state.device.point.code}&machineId=${this.$store.state.device.point.no}`,
              statistics: LAW_INQUIRE
            },
            {
              name: '律所查询',
              icon: 'yellow',
              img: 'iconlvsuochaxun',
              url: '/flsearch/2'

            },
            {
              name: '律师查询',
              icon: 'lightgreen',
              img: 'iconlvshi',
              url: '/flsearch/1'
            },
            {
              name: '经典案例',
              icon: 'red',
              img: 'iconyunshuhetong',

              url: '/caselibrary'
            },
            {
              name: '案例库查询',
              icon: 'blue',
              img: 'iconanlichakan',

              url: '/case'
            },
            {
              url: '/map/7',
              name: '法律援助机构',

              img: 'iconfalvyuanzhugongzuozhan',
              icon: 'lightred',
            },
            {
              url: '/map/2',
              name: '人民调解委员会',
              img: 'icontiaoweihuichaxun',
              icon: 'blue1'
            },
            {
              url: '/map/6',
              name: '法律服务所',
              img: 'iconfalvfuwusuo',
              icon: 'green'
            },
            {
              url: '/map/4',
              name: '司法所',
              img: 'iconfayuan',
              icon: 'yellow1'
            },
            {
              url: '/map/5',
              name: '公证处',
              img: 'icongongzhengchu',
              icon: 'lightgreen'
            },
            {
              url: '/map/1',
              name: '司法鉴定机构',
              img: 'iconsifajianding',
              icon: 'purple'
            },
            {
              url: '/map/8',
              name: '公共法律服务中心',
              img: 'icongonggongfalvfuwuzhongxin',
              icon: 'yellow'
            },
            {
              url: '/map/9',
              name: '仲裁机构',
              img: 'iconzhongcai',
              icon: 'lightblue'
            }

          ]
        }
      ],
      currentService: 0,
      scrollBox: '',
      point: '',
      isprint: '',
      soundOn: '',
      volume: '',
      scztGuide: {
        url: '/listone?id=641c149f7edc010b21b5db49&title=市场主体准入服务指南',
        name: '市场主体准入服务指南',
        img: 'iconbanzhengzhinan',
        icon: 'yellow'
      }
    }
  },
  computed: {
    showScztGuide () {
      if (this.point.config) {
        let config = JSON.parse(this.point.config)
        return config.showScztGuide
      }
      return false
    }
  },
  methods: {


    chooseService (index) {
      this.currentService = index
      let typeBox = document.getElementById('scrollBox')
      if (index === 0) {
        typeBox.scrollTop = 0
      } else if (index === 1) {
        typeBox.scrollTop = 300
      } else if (index === 2) {
        typeBox.scrollTop = 600
      } else if (index === 3) {
        typeBox.scrollTop = 880
      } else if (index === 4) {
        typeBox.scrollTop = 1360
      } else if (index === 5) {
        typeBox.scrollTop = 1840
      }
    },
    toLink (item) {
      if (item.url) {
        this.$router.push(item.url)
      }
      if (item.outerlink) {
        if (item.statistics) {
          this.$root.getStatistics(item.statistics)
          window.location.href = item.outerlink
        }
      }
    },

  },
  mounted () {
    this.point = this.$store.state.device.point
    this.isprint = this.point && this.point.is_print ? `&reportPrint=1` : ''
    this.soundOn = localStorage.soundOn
    this.volume = localStorage.volume
  }
}
</script>
<style lang="stylus" scoped>
.all-service-container
  margin 0 auto
  padding 0.2rem 0 1.6rem
  // background-color #ddd
  display flex
  .all-service-left
    width 2.3rem
    ul
      list-style none
      li
        height 0.8rem
        background rgba(255, 255, 255, 0.2)
        text-align center
        line-height 0.8rem
        color #fff
        border-radius 0.1rem
        margin-bottom 0.05rem
        border solid 1px rgba(255, 255, 255, 0.2)
        text-align center
        &.active
          background #f29530
  .all-service-right
    width 14rem
    // overflow-y scroll
    // background #fff
    // border-radius 0.1rem
    padding-bottom 420px
    .service-right-title
      font-size 0.32rem
      font-weight bold
      // padding 0.5rem 0
      padding 0.2rem 0 0.5rem 0
      color #fff
      font-family MicrosoftYaHei-Bold
    .service-right-list
      display flex
      flex-wrap wrap
      li
        width 20%
        text-align center
        margin-bottom 0.5rem
        &.new-one
          margin-top 50px
        .service-icon
          display block
          width 88%
          background-color rgba(255, 255, 255, 0.2)
          border-radius 0.08rem
          border solid 1px rgba(255, 255, 255, 0.2)
          margin-bottom 0.15rem
          color #fff
          padding 0.2rem 0
          &:active
            background-color rgba(255, 255, 255, 0.3)
            border solid 1px rgba(255, 255, 255, 0.3)
          .title
            text-overflow -o-ellipsis-lastline
            overflow hidden
            text-overflow ellipsis
            line-height 1.4
            display -webkit-box
            padding 0 6px
            -webkit-line-clamp 2
            line-clamp 2
            font-size 0.24rem
            display flex
            align-items center
            justify-content center
            -webkit-box-orient vertical
            height 0.672rem
    .img-icon
      width 0.9rem
      height 0.9rem
      text-align center
      line-height 0.9rem
      margin 0 auto 0.1rem auto
      img
        width 100%
        height 100%
    .icon
      width 0.9rem
      height 0.9rem
      border-radius 0.5rem
      text-align center
      line-height 0.9rem
      margin 0 auto 0.1rem auto
      .iconfont
        font-size 0.4rem
      &.icon-yellow
        background #fc9d0b
      &.icon-yellow1
        background #e3bf6b
      &.icon-blue
        background #3574e5
      &.icon-blue1
        background #758cd0
      &.icon-blue2
        background #6d95d2
      &.icon-red
        background #e55158
      &.icon-lightred
        background #cf7887
      &.icon-purple
        background #8f81e2
      &.icon-orange
        background #ff793f
      &.icon-green
        background #33c339
      &.icon-lightblue
        background #4c89f8
      &.icon-lightgreen
        background #38cf83
      &.icon-orange
        background #ff793f
      img
        font-size 0.5rem
        color #fff
#type-5
  margin-bottom 2rem
</style>
